import React from "react";
import { useNavigate } from "react-router-dom";
import { Eye, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useImpersonation } from "@/hooks/useImpersonation";
import { stopImpersonation } from "@/lib/admin/impersonation";

/** Syns för utvecklaren så länge en spegelvy av en användare är igång. */
const ImpersonationBanner: React.FC = () => {
  const navigate = useNavigate();
  const state = useImpersonation();

  if (!state) return null;

  return (
    <div className="my-3 flex flex-wrap items-center justify-between gap-3 rounded-lg border border-primary/40 bg-primary/10 px-4 py-2.5">
      <div className="flex items-center gap-2 text-sm">
        <Eye className="h-4 w-4 text-primary" aria-hidden="true" />
        <span>
          Du ser appen som <strong>{state.name}</strong> – skrivskyddad spegelvy.
        </span>
      </div>
      <div className="flex gap-2">
        <Button size="sm" variant="outline" onClick={() => navigate(`/admin/anvandarvy/${state.userId}`)}>
          Öppna vyn
        </Button>
        <Button size="sm" variant="ghost" onClick={stopImpersonation}>
          <X className="h-4 w-4 mr-1" />
          Avsluta
        </Button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
